"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loader;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Size = _interopRequireDefault(require("../../prop-types/Size"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  "loader": "loader__loader___3nWcm",
  "load8": "loader__load8___19W2V",
  "inline": "loader__inline___1dvL6",
  "inlineLoader": "loader__inlineLoader___107ks loader__loader___3nWcm",
  "hiddenText": "loader__hiddenText___2D6mI",
  "loading": "loader__loading___D4BqV loader__inlineLoader___107ks loader__loader___3nWcm",
  "inverse": "loader__inverse___c9RHR",
  "xs": "loader__xs___3BRXt",
  "sm": "loader__sm___qZqXO",
  "lg": "loader__lg___1e0XT",
  "xl": "loader__xl___2G0Hw",
  "slow": "loader__slow___VlEku",
  "fast": "loader__fast___KEHBH",
  "teal": "loader__teal___3ifsQ",
  "red": "loader__red___xz6lN"
};

const cx = _bind.default.bind(styles);

function Loader({
  inverse,
  inline,
  size,
  speed,
  color,
  className,
  ...rest
}) {
  return _react.default.createElement("div", _extends({
    className: cx('loader', {
      inverse,
      inline,
      [size]: styles[size]
    }, speed, color, className)
  }, rest));
}

Loader.propTypes = {
  /** Class name to apply to component */
  className: _propTypes.default.string,

  /** Boolean indicating if the loader should invert colors */
  inverse: _propTypes.default.bool,

  /** Boolean indicating if the loader should be inline */
  inline: _propTypes.default.bool,

  /** Loader size */
  size: _Size.default,

  /** Speed at which the loader spins */
  speed: _propTypes.default.oneOf(['slow', 'fast']),

  /** Button color */
  color: _propTypes.default.oneOf(['teal', 'red'])
};
Loader.defaultProps = {
  className: undefined,
  inverse: false,
  inline: false,
  size: 'md',
  speed: null,
  color: null
};